import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {TractorHistoryRequest} from '../tractors-history/tractors-history.component';
import {dateFilterToPeriod, Route, RouteLoader} from 'shared';
import {dateFilters} from 'shared';
import {DxFormComponent} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import {iif, Subscription} from 'rxjs';

@Component({
  selector: 'app-tractors-history-popup',
  templateUrl: './tractors-history-popup.component.html',
  styleUrls: ['./tractors-history-popup.component.scss']
})
export class TractorsHistoryPopupComponent implements OnInit, OnDestroy {

  @ViewChild(DxFormComponent)
  form: DxFormComponent;

  @Output()
  load = new EventEmitter<TractorHistoryRequest>();

  @Input()
  request: TractorHistoryRequest;

  @Input()
  loadingVisible = true;

  @Input()
  tractors: DataSource;
  dateFilters = dateFilters;

  @Input()
  loader: RouteLoader;
  private loaderSub: Subscription;

  stops: any = [
    {value: 5, label: '> 5 S'},
    {value: 15, label: '> 15 S'},
    {value: 30, label: '> 30 S'},
    {value: 60, label: '> 1 Min'},
    {value: 120, label: '> 2 Min'},
    {value: 5 * 60, label: '> 5 Min'},
    {value: 10 * 60, label: '> 10 Min'},
    {value: 20 * 60, label: '> 20 Min'},
    {value: 30 * 60, label: '> 30 Min'},
    {value: 60 * 60, label: '> 1 H'},
    {value: 120 * 60, label: '> 2 H'},
    {value: 300 * 60, label: '> 5 H'},
  ];
  popupVisible = true;

  constructor() {
    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
    this.dateChanged = this.dateChanged.bind(this);
    this.requestSubmit = this.requestSubmit.bind(this);
    this.requestCancel = this.requestCancel.bind(this);
  }

  ngOnInit(): void {
    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      if (!this.popupVisible) {
        return;
      }
      if (this.loader.isEmpty()) {
        return;
      }
      this.popupVisible = isLoading;
    });
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    this.request.currentFilter = e.value;
    [this.request.from, this.request.to, this.request.isToday] = dateFilterToPeriod(this.request.currentFilter);
  }

  requestSubmit(e) {
    const result = this.form.instance.validate();
    if (result.isValid) {
      this.load.emit(this.request);
    }
  }

  requestCancel(e: any) {
    this.popupVisible = false;
  }

  dateChanged(e: any) {
    /*this.currentFilter = 0;
    this.request.isToday = false;*/
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
  }

}
